import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {useAppSelector} from '@/hooks';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.types';

export function VideoBgSpeedOption(): ReactElement<any> | null {
  const currentPageBackground = useAppSelector(getCurrentPageBackground);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageBackground) {
    return null;
  }

  if (currentPageBackground.details.type !== BackgroundTypeName.VIDEO) {
    return null;
  }

  const videoDetails = currentPageBackground.details;

  const updateSpeed = async (speedValue: number, undoable: boolean): Promise<void> => {
    void currentPage?.background.updateFromObject(
      {
        details: {
          speed: speedValue,
        },
      },
      {undoable}
    );
  };

  const onSpeedEndHandler = async (val: number): Promise<void> => {
    void currentPage?.background.updateFromObject(
      {
        details: {
          speed: val,
        },
      },
      {
        undoable: true,
        checkForDurationUpdate: true,
      }
    );
  };

  return (
    <ContextualMenuSliderOptions
      id="video-bg-speed-option"
      range={{
        min: 0.5,
        max: 2,
      }}
      transformDisplay={{
        min: 0.5,
        max: 2,
      }}
      step={0.25}
      value={videoDetails.speed}
      label={window.i18next.t('pmwjs_speed')}
      onChange={(val: number): void => {
        void updateSpeed(val, false);
      }}
      onChangeEnded={(val: number): void => {
        void onSpeedEndHandler(val);
      }}
    />
  );
}
